import React, { useEffect, useState } from 'react';
import { FaBook } from "react-icons/fa";
import { GiRuleBook } from "react-icons/gi";
import './rules.css'; // Import the CSS file
import axios from 'axios';

const Rules = () => {
    const [rules, setRules] = useState('');

    // Fetch rules data on component mount
    useEffect(() => {
        const fetchRules = async () => {
            try {
                const response = await axios.get('https://backend.ems.hiradentallab.com/api/rules/'); // Adjust the URL according to your server setup
                setRules(response.data.content); // Set the content in state
            } catch (error) {
                console.error('Error fetching rules:', error);
            }
        };
        fetchRules();
    }, []);

    return (
        <div>
        <div className='container-rules'>
            <h1 className="header-h1" style={{ color: '#0353a4', textAlign: 'left' }}>
                <FaBook /> Rules
            </h1>
            <hr style={{ marginBottom: '10px' }} />
            <h1 className="header-h1" style={{ color: '#0353a4', textAlign: 'left', marginTop: '20px' }}>
                <GiRuleBook style={{ marginRight: '8px' }} /> HIRA DENTAL LAB Rules
            </h1>
            <hr style={{ marginBottom: '10px' }} />
            <div className="lab-handbook-content">
                <h3 style={{ textAlign: 'center', marginTop: '20px', fontWeight: 'bold' }}>
                Hira Tech working Rules
                </h3>
            
                <div>

                <div style={{fontSize:'18px'}} dangerouslySetInnerHTML={{ __html: rules }} />                </div>
            </div>
            </div>
            </div>
    );
};

export default Rules;
